export default __webpack_public_path__ + "static/media/bkg--LUX-interiors-1.2a060f46.jpg";